import React from 'react';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

const motionStyles = {
	initial: { scale: 0.95, opacity: 0 },
	animate: { scale: 1, opacity: 1 }
};

const Root = styled(motion.div)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column'
}));

const FadeIn = ({ children, delay = 0, rootSx, ...props }) => {
	return (
		<Root
			sx={rootSx}
			initial="hidden"
			whileInView="visible"
			viewport={{ once: true, amount: 0.5 }}
			variants={{
				visible: {
					...motionStyles.animate,
					transition: {
						ease: [0.77, 0, 0.175, 1],
						duration: 0.4,
						delay
					}
				},
				hidden: motionStyles.initial
			}}
			{...props}
		>
			{children}
		</Root>
	);
};

export default FadeIn;
